export type ResultsWaitingStatus = "awaiting_analysis" | "ready" | "collected";

export interface ResultsWaitingEntry {
  id: string;
  patientId: string;
  labOrderId: string;
  orderNumber: string;
  testName: string;
  sampleDate: string | null;
  resultReadyAt: string | null;
  notifiedAt: string | null;
  status: ResultsWaitingStatus;
  createdAt: string;
}

export const RESULTS_WAITING_STATUS_LABELS: Record<ResultsWaitingStatus, string> = {
  awaiting_analysis: "Analyse en cours",
  ready: "Résultat disponible",
  collected: "Retiré / orienté",
};
